/* uhren4you – kleine Helfer für alle Seiten (30.10.2026)
   Telefonnummern zum Antippen: die Service-Nummern +49 (0) 5405 80 444 6x werden in Texten verlinkt (tel:),
   auch in Kopfleiste, Startseite, Produktseite und den Antworten der Fragen-App.
   Die Schreibweise „540 580 444 60“ wird dabei als „5405 80 444 60“ gezeigt (Vorwahl 05405).
   Außerdem: Preis-Hinweis und Sichtbarkeit der Kaufleiste (Produktseite), Datum in Blog-Artikeln (siehe unten). */
(function () {
  var RE = /\+49[\s ]*(?:\(0\)[\s ]*)?540[\s ]*5[\s ]*80[\s ]*444[\s ]*6\d/g;
  var SKIP = /^(A|BUTTON|SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|TITLE|SVG)$/i;
  function skip(node) {
    for (var p = node.parentNode; p && p !== document.body; p = p.parentNode) {
      if (SKIP.test(p.nodeName) || p.isContentEditable) return true;
    }
    return false;
  }
  function linkify() {
    if (!document.body) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var hits = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('+49') === -1) continue;
      RE.lastIndex = 0;
      if (RE.test(n.nodeValue) && !skip(n)) hits.push(n);
    }
    hits.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var m;
      RE.lastIndex = 0;
      while ((m = RE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var a = document.createElement('a');
        a.className = 'u4y-tel';
        a.href = 'tel:+' + m[0].replace('(0)', '').replace(/\D/g, '');
        a.textContent = m[0].replace(/540([\s ]+)5(80)/, '5405$1$2');
        frag.appendChild(a);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }
  /* Kaufleiste unten (Produktseite): „inkl. MwSt. • versandkostenfrei“ bzw. „zzgl. Versandkosten“ wie am Preis oben.
     u4y-pdp.js baut die Leiste; sie kann auch erst beim Scrollen entstehen. */
  function buybarNote() {
    var info = document.querySelector('.u4y-buybar .u4y-buybar__info');
    var note = document.querySelector('.product__info-container .u4y-price-note');
    if (!info || !note) return false;
    if (!info.querySelector('.u4y-buybar__note')) {
      var p = document.createElement('p');
      p.className = 'u4y-buybar__note';
      p.innerHTML = note.innerHTML;
      info.appendChild(p);
    }
    return true;
  }
  function onScroll() {
    if (buybarNote()) window.removeEventListener('scroll', onScroll);
  }
  /* Kaufleiste auch nach Sprüngen (Sprungmarke, Zurück-Taste) richtig zeigen: u4y-pdp.js merkt nur, wenn der
     Warenkorb-Button den Bildschirmrand kreuzt. Hier zusätzlich beim Scrollen prüfen, ob er oberhalb liegt. */
  var barTick = false;
  function barCheck() {
    barTick = false;
    var bar = document.querySelector('.u4y-buybar');
    var btn = document.querySelector('.product__info-container product-form .product-form__submit[name="add"]');
    if (!bar || !btn) return;
    var r = btn.getBoundingClientRect();
    var inView = r.top < window.innerHeight && r.bottom > 0;
    var mob = window.matchMedia('(max-width: 749px)').matches;
    var want = !btn.disabled && !inView && (mob || r.bottom < 0);
    if (want !== bar.classList.contains('is-visible')) {
      bar.classList.toggle('is-visible', want);
      document.body.classList.toggle('u4y-buybar-on', want);
    }
  }
  function onBarScroll() {
    if (!barTick) {
      barTick = true;
      window.requestAnimationFrame(barCheck);
    }
  }
  /* Blog-Artikel: Datum in der Shop-Sprache („30. Oktober 2026“ statt „30. October 2026“) */
  var MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  function localDates() {
    var lang = document.documentElement.lang || 'de';
    if (lang === 'en') lang = 'en-GB';
    document.querySelectorAll('.ma__meta').forEach(function (el) {
      if (el.dataset.u4yDate) return;
      var m = el.textContent.match(/(\d{1,2})\.?\s+([A-Za-z]+)\s+(\d{4})/);
      if (!m) return;
      var mi = MONTHS.indexOf(m[2].toLowerCase());
      if (mi < 0) return;
      try {
        var txt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(+m[3], mi, +m[1]));
        el.textContent = el.textContent.replace(m[0], txt);
        el.dataset.u4yDate = '1';
      } catch (e) {}
    });
  }
  function init() {
    linkify();
    localDates();
    if (!buybarNote() && document.querySelector('.product__info-container .u4y-price-note')) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (document.querySelector('.product__info-container product-form')) {
      window.addEventListener('scroll', onBarScroll, { passive: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Inhalte von Apps (z. B. Fragen-App) erscheinen erst später */
  window.addEventListener('load', function () {
    setTimeout(function () {
      linkify();
      buybarNote();
    }, 1500);
  });
})();